module.exports = __webpack_public_path__ + "static/media/one_collecting_wave_header@2x.eebc04d9.png";